import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VRadioGroup,{attrs:{"row":_vm.row},model:{value:(_vm.submissionGroup),callback:function ($$v) {_vm.submissionGroup=$$v},expression:"submissionGroup"}},_vm._l((_vm.submissionGroups),function(item){return _c(VRadio,{key:item.Id,staticClass:"ml-6",attrs:{"value":item},scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('div',{staticClass:"black--text"},[_vm._v(" "+_vm._s(item.Name)+" ")])]},proxy:true}],null,true)})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }